import axios from 'axios'
import qs from 'qs'
export const getCouponList = (data) => {
    return axios({
        url: '/mall/phone/user/coupon/list/' ,
        method: 'get',
        params: data
    })
}

// 支付成功查询活动
export const getActivity = (data) => {
  return axios({
    url: '/mall/phone/coupon/participate/activity',
    method: 'post',
    data
  })
}
// 支付成功查询活动
export const getActivityCoupons = (data) => {
  return axios({
    url: '/mall/phone/coupon/activity/coupons',
    method: 'get',
    params: data
  })
}
// 获取公众号优惠券二维码
export const getQrcode = (data) => {
  return axios({
    url: '/mall/phone/coupon/follow/qrcode',
    method: 'get',
    params: data
  })
}

// 获取抽奖凭据
export const getFocusCoupons = (data) => {
  return axios({
    url: '/mall/phone/coupon/focus/coupons',
    method: 'post',
    data
  })
}

// 获取优惠券数量
export const getCouponCount = (data) => {
  return axios({
    url: '/mall/phone/user/coupon/count',
    method: 'get',
    params: data
  })
}





